export const countDuplicates: <T>(arr: T[]) => number = (arr) => {
    const counterObj: Record<string, number> = {};

    arr.forEach((i: any) => {
        counterObj[i] = (counterObj[i] || 0) + 1;
    });

    return arr.length - Object.keys(counterObj).length;
};
